import { Box, Grid, Typography, styled } from "@mui/material";
import UnderlineT from "../components/UnderlineT";
import address1 from "../img/address1.png";
import calendar1 from "../img/calendar1.png";
import faxt from "../img/faxt.png";
import maptec2 from "../img/maptec2.png";
import phone1 from "../img/phone1.png";

const A = styled("a")(({ theme }) => ({
  textDecoration: "none",
  display: "flex",
  alignItems: "center",
  color: theme.palette.text.primary,
  "&:hover": {
    cursor: "pointer",
    transition: "all .2s ease-in-out",
    transform: "scale(1.05)",
    transformOrigin: "center center",
  },
}));
const Img = styled("img")(({ theme }) => ({}));

function Tecumseh() {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="flex-start"
      columnGap={"100px"}
      sx={{ padding: "40px 0px", rowGap: "50px" }}
    >
      <Grid
        item
        container
        direction="column"
        rowSpacing={3}
        sx={{
          marginLeft: { xs: "0px", lg: "100px", xl: "200px" },
          width: "max-content",
        }}
      >
        <Grid item alignItems="center">
          <A href="tel:519-979-7227">
            <Img
              src={phone1}
              alt="phone"
              sx={{
                marginRight: { xs: "20px", sm: "30px" },
                width: { xs: "40px", sm: "60px" },
                height: { xs: "40px", sm: "60px" },
              }}
            />
            <Grid item>
              <Typography variant="h6" color="blue.main">
                Phone
              </Typography>
              <Typography>519-979-7227</Typography>
            </Grid>
          </A>
        </Grid>
        <Grid item alignItems="center">
          <A href={"javascript:void(0)"}>
            <Img
              src={faxt}
              alt="fax"
              sx={{
                marginRight: { xs: "20px", sm: "30px" },
                width: { xs: "40px", sm: "60px" },
                height: { xs: "40px", sm: "60px" },
              }}
            />
            <Grid item>
              <Typography variant="h6" color="teal.main">
                Fax
              </Typography>
              <Typography sx={{ maxWidth: "250px" }}>519-979-1956</Typography>
            </Grid>
          </A>
        </Grid>
        <Grid item alignItems="center">
          <A
            href="https://maps.app.goo.gl/RR1CFZ7nuH5dH26KA"
            rel="noreferrer"
            target="_blank"
          >
            <Img
              src={address1}
              alt="address"
              sx={{
                marginRight: { xs: "20px", sm: "30px" },
                width: { xs: "40px", sm: "60px" },
                height: { xs: "40px", sm: "60px" },
              }}
            />
            <Grid item>
              <Typography variant="h6" color="teal.main">
                Address
              </Typography>
              <Typography sx={{ maxWidth: "250px" }}>
                1825 Manning Rd | Studio 700 Tecumseh | ON | N9K 0A9
              </Typography>
            </Grid>
          </A>
        </Grid>
        {/* <Grid item container alignItems="center">
            <A href="mailto: info@greatlakessurgerycentre.com">
              <Img
                src={mail1}
                alt="mail"
                sx={{
                  marginRight: { xs: "20px", sm: "30px" },
                  width: { xs: "40px", sm: "60px" },
                  height: { xs: "40px", sm: "60px" },
                }}
              />
              <Grid item>
                <Typography variant="h6" color="teal.main">
                  Email
                </Typography>
                <Typography variant="subtitle1">
                  info@greatlakessurgerycentre.com
                </Typography>
              </Grid>
            </A>
          </Grid> */}
        <Grid item container direction={"row"}>
          <Img
            src={calendar1}
            alt="calendar"
            sx={{
              marginRight: { xs: "20px", sm: "30px" },
              width: { xs: "40px", sm: "60px" },
              height: { xs: "40px", sm: "60px" },
            }}
          />
          <Grid item sx={{ minWidth: "220px" }}>
            <Typography variant="h6" color="teal.main">
              Hours of Operation
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography>Monday</Typography>
              8am - 5pm
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Tuesday</Typography>
              8am - 5pm
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Wednesday</Typography>
              8am - 5pm
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Thursday</Typography>
              8am - 5pm
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Friday</Typography>
              8am - 3pm
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>Sat-Sun</Typography>
              Closed
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item justifyContent="center">
        <A
          href="https://maps.app.goo.gl/RR1CFZ7nuH5dH26KA"
          rel="noreferrer"
          target="_blank"
        >
          <img
            src={maptec2}
            alt="map"
            style={{
              width: "100%",
              maxWidth: "600px",
            }}
          />
        </A>
      </Grid>
    </Grid>
  );
}

function Locations() {
  return (
    <Grid
      container
      justifyContent="center"
      sx={{ padding: "50px 10px", width: "100%" }}
    >
      <Typography
        id="contact"
        sx={{ width: "100%", textAlign: "center" }}
        variant="h4"
      >
        Location & Hours
        <UnderlineT width="120px" />
      </Typography>
      <Tecumseh />
    </Grid>
  );
}

export default Locations;
